import { HashMap } from '@ngneat/transloco';
import { buildNotificationTranslationId } from '@platform-frontend/transloco';
import { TranslationId, buildMailToLink, buildNotificationActionLink } from '@platform-frontend/util';
import { YATTA_SUPPORT_EMAIL_ADDRESS } from './contact';
import { PLATFORM_TRANSLOCO_SCOPE } from './platform-transloco-scope';

const buildTranslationId: (key: string, params?: HashMap) => TranslationId = (key: string, params: HashMap = {}) =>
  buildNotificationTranslationId(key, params, PLATFORM_TRANSLOCO_SCOPE);

// Shared messages
export const VERIFICATION_SERVER_UNREACHABLE_NOTIFICATION = buildTranslationId('shared.verificationServerUnreachable');
export const NEW_EMAIL_SENT_NOTIFICATION = buildTranslationId('shared.newEmailSent');
export const NEW_EMAIL_FAILED_NOTIFICATION = (action?: object): TranslationId =>
  buildTranslationId(action ? 'shared.newEmailFailed.default.withTryAgainLink' : 'shared.newEmailFailed.default.withoutTryAgainLink', {
    tryAgainLink: action ? buildNotificationActionLink(action, undefined, '7b76ec74-4c2d-4c58-a21f-73a4d13aadf8') : undefined
  });
export const NEW_EMAIL_FAILED_SERVER_UNREACHABLE_NOTIFICATION = (action: object): TranslationId =>
  buildTranslationId('shared.newEmailFailed.serverUnreachable', {
    tryAgainLink: buildNotificationActionLink(action, undefined, '5501aeb3-29b7-48e3-a15c-73c5b78453fe')
  });
export const MAX_MAIL_REQUESTS_EXCEEDED_NOTIFICATION = buildTranslationId('shared.maxMailRequestsExceeded');
export const DELETE_INSTANCE_DEFAULT_NOTIFICATION = buildTranslationId('shared.deleteInstanceDefault');

// Global platform-related errors
export const MSG_PLATFORM_SERVER_UNREACHABLE = buildTranslationId('global.serverUnreachable');
export const MSG_PLATFORM_MAX_REQUESTS_EXCEEDED = buildTranslationId('global.maxRequestsExceeded');
export const MSG_PLATFORM_NO_ACCESS = buildTranslationId('global.noAccess.message', {
  supportMailLink: buildMailToLink(
    YATTA_SUPPORT_EMAIL_ADDRESS,
    buildTranslationId('global.noAccess.mailToYattaSupport.subject'),
    null,
    '2f8d3de0-6747-4556-ae19-8b63a10b67b8'
  )
});
export const MSG_PLATFORM_NOT_FOUND = buildTranslationId('global.notFound');
export const MSG_PLATFORM_DEFAULT = buildTranslationId('global.default');

// Autostart
export const MSG_AUTOSTART_DEFAULT = buildTranslationId('autostart.default');
